






























































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Icon from '@/main-components/common/Icon.vue';
import { OnSubmitInput } from '../Form.vue';
import Label from '../Label.vue';

export interface DropdownOption {
  value: string | number | boolean | null; // NOTE: Must be unique
  text: string;
  isSelected: boolean;
}

@Component({
  components: { Icon, Label },
})
export default class Dropdown extends Vue {
  @Prop({ required: true })
  name: string;

  @Prop({ default: 'Dropdown Option' })
  placeholder: string;

  @Prop({ default: 'No Option Available' })
  placeholderForEmptyOptions: string;

  @Prop({ default: false })
  isMultiSelect: boolean;

  @Prop({ default: false })
  isRequired: boolean;

  @Prop({ default: false })
  isCannotUnselect: boolean;

  @Prop({ default: false })
  isUpdateOnSelect: boolean;

  @Prop({ default: false })
  isHideDefaultInput: boolean;

  @Prop({ default: false })
  showLabel: boolean;

  @Prop({ required: true })
  dropdownOptions: DropdownOption[];

  @Prop({ default: null })
  initialSelectedOption: string | number | null;

  @Prop({ default: null })
  initialSelectedOptions: string[] | number[] | null;

  @Prop({ default: null })
  parentError: string | boolean | null;

  @Prop({ default: false })
  dropdownOptionsWidth: string | boolean;

  get iconColor() {
    return getComputedStyle(document.body).getPropertyValue(
      '--color-gray-dark-secondary',
    );
  }

  options: DropdownOption[] = [];
  showOptions = false;
  selectedOption: DropdownOption | null = null;
  selectedOptions: DropdownOption[] = [];
  error: string | boolean = false;

  created() {
    this.initOptionsAndSelectedOption();
    this.$emit('addSubmitInput', this.submitInput);
  }

  toggleShowOptions() {
    if (this.showOptions) {
      this.closeOptions();
    } else {
      this.openOptions();
    }
  }

  optionClick(option: DropdownOption) {
    if (!option.value && this.isCannotUnselect) return;

    if (this.selectedOption) {
      this.selectedOption.isSelected = false;
    }

    if (option.value === this.selectedOption?.value) {
      this.selectedOption = null;
    } else if (option.value) {
      this.selectedOption = option;
      option.isSelected = true;
    } else {
      this.selectedOption = null;
    }

    if (this.isUpdateOnSelect) {
      this.$emit('onOptionClicked', this.selectedOption);
    }

    this.closeOptions();
  }

  optionMultiClick(option: DropdownOption) {
    if (!option.value) return;

    // NOTE: value equal to reset is reserved for resetting selectedOptions
    if (option.value === 'reset') {
      this.selectedOptions = [];

      this.options
        .filter(option => option.isSelected)
        .forEach(option => {
          option.isSelected = false;
        });
    } else {
      const existingSelectedOption = this.selectedOptions.findIndex(
        selectedOption => selectedOption.value === option.value,
      );

      if (existingSelectedOption !== -1) {
        option.isSelected = false;
        this.selectedOptions.splice(existingSelectedOption, 1);
      } else {
        option.isSelected = true;
        this.selectedOptions.push(option);
      }
    }

    if (this.isUpdateOnSelect) {
      this.$emit('onOptionClicked', this.selectedOptions);
    }
  }

  openOptions() {
    document.addEventListener('click', this.onClickOutside);
  }

  closeOptions() {
    document.removeEventListener('click', this.onClickOutside);
    this.showOptions = false;
  }

  onClickOutside() {
    if (this.showOptions) {
      this.closeOptions();
      this.showOptions = false;
    } else {
      this.showOptions = true;
    }
  }

  submitInput(): OnSubmitInput {
    let hasError = false;
    let value: string | number | boolean | (string | number | boolean)[] = '';

    if (this.isRequired) {
      if (this.isMultiSelect && !this.selectedOptions.length) {
        hasError = true;
        this.error = 'Must select at least one';
      }

      if (!this.isMultiSelect && !this.selectedOption) {
        hasError = true;
        this.error = 'Must be selected';
      }
    }

    if (
      !this.isMultiSelect &&
      this.selectedOption &&
      this.selectedOption.value
    ) {
      value = this.selectedOption.value;
    }

    if (
      this.isMultiSelect &&
      this.selectedOptions &&
      this.selectedOptions.length
    ) {
      value = this.selectedOptions.map(selectedOption => {
        return selectedOption.value ? selectedOption.value : '';
      });
    }

    if (!hasError) {
      this.error = false;
    }

    return {
      hasError,
      value,
      name: this.name,
    };
  }

  initInitialSelectedOptions() {
    this.selectedOption = null;
    this.selectedOptions = [];

    if (!this.isMultiSelect && this.initialSelectedOption) {
      const initialOption = this.options.find(
        option => option.value === this.initialSelectedOption,
      );

      if (initialOption) {
        initialOption.isSelected = true;
        this.selectedOption = initialOption;
      }
    }

    if (this.isMultiSelect && this.initialSelectedOptions) {
      this.initialSelectedOptions.forEach(
        (initialSelectedOption: string | number) => {
          const initialOption = this.options.find(
            option => option.value === initialSelectedOption,
          );

          if (initialOption) {
            initialOption.isSelected = true;
            this.selectedOptions.push(initialOption);
          }
        },
      );
    }
  }

  initOptionsAndSelectedOption() {
    this.options = [];
    this.options = [...this.dropdownOptions];

    if (this.options.length) {
      if (this.isMultiSelect) {
        // NOTE: To add option for user to reset selected options
        this.options.unshift({
          value: 'reset',
          text: 'Reset Selection',
          isSelected: false,
        });
      }

      this.options.unshift({
        value: null,
        text: this.placeholder,
        isSelected: false,
      });
    } else {
      this.options.push({
        value: null,
        text: this.placeholderForEmptyOptions,
        isSelected: false,
      });
    }

    this.initInitialSelectedOptions();
  }

  @Watch('dropdownOptions')
  dropdownOptionsChange() {
    this.initOptionsAndSelectedOption();
  }

  @Watch('initialSelectedOption')
  initialSelectedOptionChange() {
    this.initInitialSelectedOptions();
  }

  @Watch('initialSelectedOptions')
  initialSelectedOptionsChange() {
    this.initInitialSelectedOptions();
  }

  @Watch('parentError')
  parentErrorChange() {
    if (this.parentError !== null) {
      this.error = this.parentError;
    }
  }
}
